import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  marginTp: {
    fontSize: 26,
    marginTop: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(1.5),
      fontSize: 17,
    },
  },

  textTitle: {
    fontSize: 36,
    [theme.breakpoints.down("sm")]: {
      fontSize: 21,
    },
  },

  header: {
    marginTop: theme.spacing(11),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(5),
    },
  },
}));

const CancerIntroHeader = ({ cancer = "폐암" }) => {
  const classes = useStyles();
  return (
    <Grid
      container
      justify="center"
      direction="column"
      alignItems="center"
      className={classes.header}
    >
      <Typography variant="h2" align="center" className={classes.textTitle}>
        {cancer} 조기검진을 받아야 할까요?
      </Typography>
      <Typography
        variant="h4"
        color="textSecondary"
        align="center"
        className={classes.marginTp}
      >
        아래와 같은 순서대로 살펴보겠습니다.
      </Typography>
    </Grid>
  );
};

export default CancerIntroHeader;
